import Tooltip from '@cpg-its/ads.common.tooltip';
import { FormikProps } from 'formik';
import React from 'react';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { labelSupplementStyles } from '../../../../../global/constants/theme/styles/components/label-supplement-styles';
import { tcsmColors } from '../../../../../global/constants/theme/theme-constants/colors';
import { TerminationProps } from '../../../models/arc-epi-props';
import { TerminationFormValues } from '../models/termination-form-model';

interface Props {
    formProps: FormikProps<TerminationFormValues>;
    terminationProps: TerminationProps;
}
export function EmploymentDeathFields(props: Props) {
    const { formProps, terminationProps } = props;
    const headerClasses = labelSupplementStyles();
    return (
        <DividerSection removeDivider>

            <FormField
                name='termination_date'
                label={terminationProps?.dateOfDeathLabel}
                component='datePicker'
                touched={formProps.touched}
                errors={formProps.errors}
                required
                autoWidth
            />
            <div className={headerClasses.labelLayout}>
                <p className='caption'><strong>{terminationProps?.dontKnowDateText}</strong></p>
                <div className='supplement-wrapper'><Tooltip iconColor={tcsmColors.blue} title={terminationProps?.dontKnowDeathDateTooltip} /></div>
            </div>
        </DividerSection>
    );
}